import React, { useState } from 'react';

const HomePage: React.FC = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    telefone: '',
    idade: '',
    situacao: '',
    mensagem: ''
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });

    try {
      const response = await fetch('https://readdy.ai/api/form/d3o06c696su78r6hev9g', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        alert('Formulário enviado com sucesso! Entraremos em contato em breve.');
        setFormData({
          nome: '',
          email: '',
          telefone: '',
          idade: '',
          situacao: '',
          mensagem: ''
        });
      } else {
        alert('Erro ao enviar formulário. Tente novamente.');
      }
    } catch (error) {
      alert('Erro ao enviar formulário. Tente novamente.');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const whatsappNumber = "5511975410994";

  return (
    <div className="min-h-screen bg-gradient-to-b from-pink-50 to-purple-50">
      {/* Header */}
      <header className="bg-white/90 backdrop-blur-sm shadow-sm fixed w-full top-0 z-50">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <img 
                src="https://static.readdy.ai/image/1fa5c401bb5ee913d2f701c7bc3be513/c6cd3e25a8ec54be63dc59ed3af10fc3.png" 
                alt="Flor do Bem" 
                className="h-12 w-auto"
              />
            </div>
            <a
              href={`https://wa.me/${whatsappNumber}?text=Olá! Gostaria de saber mais sobre o Programa Flor do Bem`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-full flex items-center space-x-2 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="fab fa-whatsapp text-lg"></i>
              <span>Falar com especialista</span>
            </a>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section 
        className="pt-24 pb-16 relative overflow-hidden"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/90a6c2fc82adde6f96fae7937c82a1bd.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-white/95 via-white/80 to-white/70"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="flex justify-center items-center min-h-[500px]">
            <div className="text-center max-w-4xl space-y-8">
              <div className="space-y-6">
                <div className="flex flex-col items-center space-y-3">
                  <h1 className="text-2xl font-semibold text-purple-900">Programa</h1>
                  <img 
                    src="https://static.readdy.ai/image/1fa5c401bb5ee913d2f701c7bc3be513/c6cd3e25a8ec54be63dc59ed3af10fc3.png" 
                    alt="Flor do Bem" 
                    className="h-24 w-auto"
                  />
                </div>
                <p className="text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
                  Uma jornada de 3 meses para mulheres com mais de 40 anos que buscam 
                  <strong className="text-purple-700"> reconexão, equilíbrio e leveza</strong> através 
                  de florais alquímicos personalizados
                </p>
              </div>

              <div className="bg-white/90 backdrop-blur-sm rounded-2xl p-6 shadow-lg max-w-2xl mx-auto">
                <h3 className="text-lg font-semibold text-purple-900 mb-4">
                  ✨ Em até 3 meses você vai sair de:
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="space-y-2">
                    <p className="text-red-600 flex items-center justify-center md:justify-start">
                      <i className="ri-close-circle-line mr-2"></i>
                      Exaustão e ansiedade
                    </p>
                    <p className="text-red-600 flex items-center justify-center md:justify-start">
                      <i className="ri-close-circle-line mr-2"></i>
                      Desconexão emocional
                    </p>
                    <p className="text-red-600 flex items-center justify-center md:justify-start">
                      <i className="ri-close-circle-line mr-2"></i>
                      Baixa autoestima
                    </p>
                  </div>
                  <div className="space-y-2">
                    <p className="text-green-600 flex items-center justify-center md:justify-start">
                      <i className="ri-check-circle-line mr-2"></i>
                      Energia e vitalidade
                    </p>
                    <p className="text-green-600 flex items-center justify-center md:justify-start">
                      <i className="ri-check-circle-line mr-2"></i>
                      Clareza emocional
                    </p>
                    <p className="text-green-600 flex items-center justify-center md:justify-start">
                      <i className="ri-check-circle-line mr-2"></i>
                      Confiança e bem-estar
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a
                  href={`https://wa.me/${whatsappNumber}?text=Quero saber se o Programa Flor do Bem é pra mim`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 hover:bg-green-6 text-white px-8 py-4 rounded-full text-lg font-semibold flex items-center justify-center space-x-2 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="fab fa-whatsapp text-xl"></i>
                  <span>Quero saber se é pra mim</span>
                </a>
                <a
                  href="#metodologia"
                  className="bg-purple-100 hover:bg-purple-200 text-purple-700 px-8 py-4 rounded-full text-lg font-semibold text-center transition-colors whitespace-nowrap cursor-pointer"
                >
                  Conhecer o método
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Para Quem É */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-purple-900 mb-4">
              Este programa é para você que...
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Mulheres maduras e conscientes que buscam um olhar para dentro
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "ri-heart-pulse-line",
                title: "Vive fases de transição",
                description: "Menopausa, separações, filhos crescidos, recomeços"
              },
              {
                icon: "ri-emotion-unhappy-line",
                title: "Sente ansiedade e sensibilidade",
                description: "Física e emocional, sem encontrar acolhimento real"
              },
              {
                icon: "ri-search-eye-line",
                title: "Já buscou ajuda",
                description: "Médicos, terapias e conteúdos de bem-estar"
              },
              {
                icon: "ri-heart-line",
                title: "Priorizou os outros",
                description: "Anos cuidando de todos, menos de si mesma"
              },
              {
                icon: "ri-plant-line",
                title: "Busca algo natural",
                description: "Processo humano e transformador"
              },
              {
                icon: "ri-user-heart-line",
                title: "Quer se comprometer ativamente",
                description: "Não busca soluções rápidas ou milagrosas"
              }
            ].map((item, index) => (
              <div key={index} className="bg-gradient-to-br from-pink-50 to-purple-50 p-6 rounded-2xl text-center">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-semibold text-purple-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href={`https://wa.me/${whatsappNumber}?text=Me identifiquei com o perfil! Quero começar meu primeiro mês`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-6 text-white px-8 py-4 rounded-full text-lg font-semibold inline-flex items-center space-x-2 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="fab fa-whatsapp text-xl"></i>
              <span>Quero começar meu primeiro mês</span>
            </a>
          </div>
        </div>
      </section>

      {/* Metodologia */}
      <section id="metodologia" className="py-16 bg-gradient-to-b from-purple-50 to-pink-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-purple-900 mb-4">
              Metodologia dos 4 Pilares
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Uma jornada progressiva e estruturada para sua transformação
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8">
            {[
              {
                number: "1",
                title: "Escuta e Diagnóstico Profundo",
                description: "Acolhimento e identificação das causas raízes dos seus desafios emocionais e físicos",
                color: "from-pink-400 to-rose-400"
              },
              {
                number: "2",
                title: "Limpeza e Harmonização",
                description: "Uso de florais alquímicos para liberar bloqueios e aliviar sintomas físicos e emocionais",
                color: "from-purple-400 to-pink-400"
              },
              {
                number: "3",
                title: "Reconexão com a Essência",
                description: "Fortalecimento da autoestima e desenvolvimento de práticas de autocuidado",
                color: "from-indigo-400 to-purple-400"
              },
              {
                number: "4",
                title: "Sustentação e Autonomia",
                description: "Criação de uma rotina leve e possível para manter a transformação no dia a dia",
                color: "from-teal-400 to-indigo-400"
              }
            ].map((pilar, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg">
                <div className="flex items-start space-x-4">
                  <div className={`w-12 h-12 bg-gradient-to-r ${pilar.color} rounded-full flex items-center justify-center text-white font-bold text-xl flex-shrink-0`}>
                    {pilar.number}
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-purple-900 mb-3">{pilar.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{pilar.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <a
              href={`https://wa.me/${whatsappNumber}?text=Quero conhecer mais sobre a metodologia dos 4 pilares`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-full text-lg font-semibold inline-flex items-center space-x-2 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="fab fa-whatsapp text-xl"></i>
              <span>Tirar dúvida no WhatsApp</span>
            </a>
          </div>
        </div>
      </section>

      {/* Estrutura do Programa */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-purple-900 mb-4">
              Estrutura do Programa - 3 Meses
            </h2>
            <p className="text-xl text-gray-600">
              Uma jornada dividida em fases progressivas
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {[
              {
                mes: "Mês 1",
                titulo: "Raízes da Cura",
                itens: [
                  "Escuta e diagnóstico profundo",
                  "Mapa Alquímico personalizado",
                  "Florais específicos e complementares",
                  "Checkpoint de acompanhamento",
                  "Suporte via WhatsApp"
                ],
                cor: "from-pink-400 to-rose-400"
              },
              {
                mes: "Mês 2",
                titulo: "Florescer Interior",
                itens: [
                  "Análise de evolução",
                  "Novos florais personalizados",
                  "Ajustes na fórmula",
                  "Acompanhamento contínuo",
                  "Materiais de apoio"
                ],
                cor: "from-purple-400 to-pink-400"
              },
              {
                mes: "Mês 3",
                titulo: "Essência Viva",
                itens: [
                  "Consolidação dos resultados",
                  "Relatório final de evolução",
                  "Plano de manutenção",
                  "Autonomia conquistada",
                  "Transformação sustentável"
                ],
                cor: "from-indigo-400 to-purple-400"
              }
            ].map((fase, index) => (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 shadow-lg border border-gray-100">
                <div className={`w-full h-2 bg-gradient-to-r ${fase.cor} rounded-full mb-6`}></div>
                <h3 className="text-2xl font-bold text-purple-900 mb-2">{fase.mes}</h3>
                <h4 className="text-xl font-semibold text-gray-700 mb-6">{fase.titulo}</h4>
                <ul className="space-y-3">
                  {fase.itens.map((item, itemIndex) => (
                    <li key={itemIndex} className="flex items-start space-x-3">
                      <i className="ri-check-circle-fill text-green-500 text-lg mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-600">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Planos e Valores */}
      <section className="py-16 bg-gradient-to-b from-purple-50 to-pink-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-purple-900 mb-4">
              Planos e Investimento
            </h2>
            <p className="text-xl text-gray-600">
              Escolha a opção ideal para sua jornada de transformação
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {/* Consulta Inicial */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-purple-900 mb-2">Consulta Inicial</h3>
                <div className="text-4xl font-bold text-pink-500 mb-2">R$ 300</div>
                <p className="text-gray-600">Diagnóstico e direcionamento personalizado</p>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-green-500 text-lg mt-0.5"></i>
                  <span>Diagnóstico completo e profundo</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-green-500 text-lg mt-0.5"></i>
                  <span>Direcionamento personalizado</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-information-line text-blue-500 text-lg mt-0.5"></i>
                  <span>Valor abatido em programas futuros</span>
                </li>
              </ul>
              <a
                href={`https://wa.me/${whatsappNumber}?text=Quero agendar minha Consulta Inicial de R$ 300`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-purple-600 hover:bg-purple-700 text-white py-3 rounded-full font-semibold text-center block transition-colors whitespace-nowrap cursor-pointer"
              >
                Agendar Consulta
              </a>
            </div>

            {/* Programa 1 Mês */}
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-purple-900 mb-2">Programa 1 Mês</h3>
                <div className="text-4xl font-bold text-pink-500 mb-2">R$ 750</div>
                <p className="text-gray-600">Primeiro passo da transformação</p>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-green-500 text-lg mt-0.5"></i>
                  <span>1 consulta personalizada</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-green-500 text-lg mt-0.5"></i>
                  <span>Florais específicos e complementares</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-green-500 text-lg mt-0.5"></i>
                  <span>Mapa Alquímico personalizado</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-green-500 text-lg mt-0.5"></i>
                  <span>Suporte e materiais de apoio</span>
                </li>
              </ul>
              <a
                href={`https://wa.me/${whatsappNumber}?text=Quero começar o Programa de 1 mês por R$ 750`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-green-500 hover:bg-green-600 text-white py-3 rounded-full font-semibold text-center block transition-colors whitespace-nowrap cursor-pointer"
              >
                Começar Agora
              </a>
            </div>

            {/* Programa 3 Meses - Destaque */}
            <div className="bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl p-8 shadow-xl text-white relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-yellow-400 text-purple-900 px-4 py-1 rounded-full text-sm font-bold">
                  MAIS POPULAR
                </span>
              </div>
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold mb-2">Programa Completo</h3>
                <div className="text-4xl font-bold mb-1">R$ 1.997</div>
                <div className="text-lg opacity-90 mb-2">R$ 667/mês</div>
                <p className="opacity-90">Transformação completa em 3 meses</p>
              </div>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-yellow-300 text-lg mt-0.5"></i>
                  <span>3 consultas + check-ins</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-yellow-300 text-lg mt-0.5"></i>
                  <span>6 florais personalizados</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-yellow-300 text-lg mt-0.5"></i>
                  <span>Suporte contínuo WhatsApp</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-yellow-300 text-lg mt-0.5"></i>
                  <span>Todos os materiais de apoio</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-circle-fill text-yellow-300 text-lg mt-0.5"></i>
                  <span>Relatório final de evolução</span>
                </li>
              </ul>
              <a
                href={`https://wa.me/${whatsappNumber}?text=Quero fazer o Programa Completo de 3 meses por R$ 1.997`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full bg-white text-purple-600 py-3 rounded-full font-bold text-center block hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Quero a Transformação Completa
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Entregas e Experiência */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-purple-900 mb-4">
              O que você vai receber
            </h2>
            <p className="text-xl text-gray-600">
              Uma experiência completa de cuidado e transformação
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: "ri-map-2-line",
                title: "Mapa Alquímico",
                description: "Guia personalizado com diagnóstico, florais e metas específicas para sua jornada"
              },
              {
                icon: "ri-flask-line",
                title: "Florais Alquímicos",
                description: "Enviados diretamente para sua casa, personalizados para suas necessidades"
              },
              {
                icon: "ri-book-open-line",
                title: "Materiais de Apoio",
                description: "Diário das Emoções, E-book 'Primeiros 30 dias' e 3 meditações guiadas"
              },
              {
                icon: "ri-tarot-line",
                title: "Oráculo das Flores",
                description: "Ferramenta especial utilizada nas consultas para insights profundos"
              },
              {
                icon: "ri-customer-service-2-line",
                title: "Suporte Humano",
                description: "Acompanhamento empático via WhatsApp com respostas em até 48h"
              },
              {
                icon: "ri-file-chart-line",
                title: "Relatório de Evolução",
                description: "Documento final mostrando sua transformação e conquistas tangíveis"
              }
            ].map((item, index) => (
              <div key={index} className="text-center p-6">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-xl font-semibold text-purple-900 mb-3">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Resultados Esperados */}
      <section className="py-16 bg-gradient-to-b from-purple-50 to-pink-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-purple-900 mb-4">
              Resultados que você pode esperar
            </h2>
            <p className="text-xl text-gray-600">
              Transformações reais e mensuráveis em sua vida
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <div className="space-y-6">
                {[
                  {
                    icon: "ri-moon-line",
                    title: "Melhora do sono e disposição",
                    description: "Noites mais tranquilas e dias com mais energia"
                  },
                  {
                    icon: "ri-heart-pulse-line",
                    title: "Estabilidade emocional",
                    description: "Redução da ansiedade e maior equilíbrio interno"
                  },
                  {
                    icon: "ri-shield-heart-line",
                    title: "Alívio das dores físicas",
                    description: "Diminuição de tensões e desconfortos corporais"
                  },
                  {
                    icon: "ri-user-heart-line",
                    title: "Autoconfiança renovada",
                    description: "Retorno da sensação de pertencimento e valor próprio"
                  },
                  {
                    icon: "ri-sun-line",
                    title: "Reconexão com o prazer",
                    description: "Redescoberta da alegria e leveza de viver"
                  },
                  {
                    icon: "ri-compass-3-line",
                    title: "Clareza para mudanças",
                    description: "Equilíbrio para lidar com as transições da vida"
                  }
                ].map((resultado, index) => (
                  <div key={index} className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-r from-pink-400 to-purple-400 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className={`${resultado.icon} text-white text-xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-purple-900 mb-1">{resultado.title}</h3>
                      <p className="text-gray-600">{resultado.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="text-center">
              <img 
                src="https://readdy.ai/api/search-image?query=Happy%20confident%20mature%20woman%20in%20her%2040s%20smiling%20peacefully%2C%20surrounded%20by%20beautiful%20flowers%20and%20natural%20elements%2C%20wellness%20transformation%20concept%2C%20bright%20natural%20lighting%2C%20serene%20garden%20setting%2C%20professional%20lifestyle%20photography&width=500&height=600&seq=resultados-flor-do-bem&orientation=portrait"
                alt="Mulher transformada"
                className="rounded-2xl shadow-lg mx-auto object-cover w-full max-w-md"
              />
            </div>
          </div>

          <div className="text-center mt-12">
            <a
              href={`https://wa.me/${whatsappNumber}?text=Quero conquistar esses resultados! Como funciona o programa?`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold inline-flex items-center space-x-2 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="fab fa-whatsapp text-xl"></i>
              <span>Quero esses resultados</span>
            </a>
          </div>
        </div>
      </section>

      {/* Formulário de Consulta */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-3xl lg:text-4xl font-bold text-purple-900 mb-4">
                Agende sua Consulta Inicial
              </h2>
              <p className="text-xl text-gray-600">
                Preencha o formulário e entraremos em contato em breve
              </p>
            </div>

            <form onSubmit={handleSubmit} className="bg-gradient-to-br from-purple-50 to-pink-50 p-8 rounded-2xl shadow-lg" data-readdy-form>
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="nome" className="block text-sm font-medium text-purple-900 mb-2">
                    Nome completo *
                  </label>
                  <input
                    type="text"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                    placeholder="Seu nome completo"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-purple-900 mb-2">
                    E-mail *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                    placeholder="seu@email.com"
                  />
                </div>

                <div>
                  <label htmlFor="telefone" className="block text-sm font-medium text-purple-900 mb-2">
                    WhatsApp *
                  </label>
                  <input
                    type="tel"
                    id="telefone"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm"
                    placeholder="(11) 99999-9999"
                  />
                </div>

                <div>
                  <label htmlFor="idade" className="block text-sm font-medium text-purple-900 mb-2">
                    Idade *
                  </label>
                  <select
                    id="idade"
                    name="idade"
                    value={formData.idade}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm pr-8"
                  >
                    <option value="">Selecione sua faixa etária</option>
                    <option value="35-40">35-40 anos</option>
                    <option value="40-45">40-45 anos</option>
                    <option value="45-50">45-50 anos</option>
                    <option value="50-55">50-55 anos</option>
                    <option value="55-60">55-60 anos</option>
                    <option value="60+">60+ anos</option>
                  </select>
                </div>
              </div>

              <div className="mt-6">
                <label htmlFor="situacao" className="block text-sm font-medium text-purple-900 mb-2">
                  Qual sua principal situação atual? *
                </label>
                <select
                  id="situacao"
                  name="situacao"
                  value={formData.situacao}
                  onChange={handleInputChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm pr-8"
                >
                  <option value="">Selecione a situação que mais se identifica</option>
                  <option value="menopausa">Menopausa</option>
                  <option value="separacao">Separação/Divórcio</option>
                  <option value="filhos-crescidos">Filhos crescidos/saindo de casa</option>
                  <option value="recomecos">Recomeços profissionais</option>
                  <option value="ansiedade">Ansiedade e estresse</option>
                  <option value="baixa-autoestima">Baixa autoestima</option>
                  <option value="outros">Outros</option>
                </select>
              </div>

              <div className="mt-6">
                <label htmlFor="mensagem" className="block text-sm font-medium text-purple-900 mb-2">
                  Conte um pouco sobre o que você está vivendo
                </label>
                <textarea
                  id="mensagem"
                  name="mensagem"
                  value={formData.mensagem}
                  onChange={handleInputChange}
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm resize-none"
                  placeholder="Compartilhe brevemente seus desafios e o que espera do programa..."
                ></textarea>
                <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
              </div>

              <div className="mt-8">
                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                >
                  Agendar Minha Consulta Inicial
                </button>
              </div>

              <p className="text-xs text-gray-500 text-center mt-4">
                Ao enviar, você concorda em receber contato via WhatsApp para agendamento da consulta.
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16 bg-gradient-to-r from-purple-600 to-pink-600 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Pronta para sua transformação?
          </h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto opacity-90">
            Não espere mais para reconectar-se com sua essência e viver com leveza, 
            equilíbrio e confiança. Sua jornada de cura começa agora.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={`https://wa.me/${whatsappNumber}?text=Estou pronta para minha transformação! Quero começar o Programa Flor do Bem`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full text-lg font-semibold inline-flex items-center justify-center space-x-2 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="fab fa-whatsapp text-xl"></i>
              <span>Começar minha jornada agora</span>
            </a>
            <a
              href={`https://wa.me/${whatsappNumber}?text=Tenho dúvidas sobre o Programa Flor do Bem. Podem me ajudar?`}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white/20 hover:bg-white/30 text-white px-8 py-4 rounded-full text-lg font-semibold inline-flex items-center justify-center space-x-2 transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              <i className="ri-question-line text-xl"></i>
              <span>Ainda tenho dúvidas</span>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-purple-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <img 
                  src="https://static.readdy.ai/image/1fa5c401bb5ee913d2f701c7bc3be513/c6cd3e25a8ec54be63dc59ed3af10fc3.png" 
                  alt="Flor do Bem" 
                  className="h-10 w-auto"
                />
              </div>
              <p className="text-purple-200 mb-4">
                Programa de acompanhamento terapêutico para mulheres que buscam reconexão, 
                equilíbrio e leveza através de florais alquímicos personalizados.
              </p>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Contato</h4>
              <div className="space-y-2">
                <a
                  href={`https://wa.me/${whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-purple-200 hover:text-white transition-colors cursor-pointer"
                >
                  <i className="fab fa-whatsapp"></i>
                  <span>WhatsApp</span>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Investimento</h4>
              <ul className="space-y-2 text-purple-200">
                <li>Consulta Inicial - R$ 300</li>
                <li>Programa 1 mês - R$ 750</li>
                <li>Programa 3 meses - R$ 1.997</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-purple-800 mt-8 pt-8 text-center">
            <p className="text-purple-200">
              © 2025 Programa Flor do Bem. Todos os direitos reservados. | 
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white ml-1 cursor-pointer">
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
